import React from 'react'
import { Box, Heading, Text } from './ui'
import './PageHero.css'

interface PageHeroProps {
  badge: string
  title: string
  subtitle: string
}

const PageHero: React.FC<PageHeroProps> = ({ badge, title, subtitle }) => {
  return (
    <Box className="page-hero">
      <Text className="hero-badge">
        {badge}
      </Text>
      <Heading as="h1" size="9" className="page-hero-title">
        {title}
      </Heading>
      <Text className="page-hero-subtitle" size="4">
        {subtitle}
      </Text>
    </Box>
  )
}

export default PageHero

